// extracted by mini-css-extract-plugin
export var container = "Ri5Ut";
export var main = "XNxPn";
export var slide = "SuwZR";
export var slides = "_11iHA";
export var video = "njcGy";